import React from 'react';
import { Construction } from 'lucide-react';
import Layout from './Layout';

/**
 * PageShell - A reusable wrapper for pages under construction
 * Provides consistent styling and a placeholder message
 */
const PageShell = ({ title, description, icon: Icon, children }) => {
    return (
        <Layout>
            <div className="px-6 py-8">
                {/* Page header */}
                <div className="mb-8">
                    <div className="flex items-center gap-3 mb-2">
                        {Icon && (
                            <div className="w-10 h-10 bg-emerald-50 rounded-xl flex items-center justify-center">
                                <Icon size={20} className="text-emerald-600" />
                            </div>
                        )}
                        <h1 className="text-2xl font-display font-bold text-gray-900">
                            {title}
                        </h1>
                    </div>
                    {description && (
                        <p className="text-gray-500 ml-13">{description}</p>
                    )}
                </div>

                {/* Page content */}
                {children || (
                    <div className="bg-white rounded-2xl border border-gray-200 p-12 text-center">
                        <div className="w-16 h-16 bg-amber-50 rounded-2xl flex items-center justify-center mx-auto mb-4">
                            <Construction size={28} className="text-amber-500" />
                        </div>
                        <h2 className="text-lg font-semibold text-gray-900 mb-2">
                            Coming soon
                        </h2>
                        <p className="text-gray-500 max-w-md mx-auto">
                            This page is under construction. Check back soon for updates!
                        </p>
                    </div>
                )}
            </div>
        </Layout>
    );
};

export default PageShell;